import React from "react";
import Linkify from "react-linkify";
import appConstants from "../../../../../appConstants";
import MessageMetaData from "./MessageMetaData";
import ChoiceRenderer from "../Header/MCQMessages/ChoiceRenderer";

const ReplyTextMessage = (props) => {
  const { classes } = props;
  return (
    <React.Fragment>
      {props.msg.parentMessage.messageType ===
      appConstants.MESSAGE_TYPE.Dispatcher ? (
        <div
          className={`${classes.scMessageText} ${classes.scMessageContentSentScMessagText}`}
        >
          <div className={`${classes.scMessageContentSentReply} ${props.msg.parentMessage.isUrgent ? classes.urgentMessage : ""}`}>
            <Linkify properties={{ target: "_blank" }}>
              {props.msg.parentMessage.message}
              {props.msg.parentMessage.choice?.length > 0 && (
                <ChoiceRenderer choiceData={props.msg.parentMessage.choice} />
              )}
            </Linkify>
            <div className={classes.timeStyle}>
              {props.convertTime(props.msg.parentMessage.messageDateTs)}{" "}
              {props.renderReadIcon(props.msg.parentMessage.isRead, classes)}
            </div>
          </div>
          <div className={classes.messageContainer}>
            <Linkify properties={{ target: "_blank" }}>
              {props.msg.metadata && (
                <MessageMetaData
                  color={props.metadataColor}
                  metadata={props.msg.metadata}
                ></MessageMetaData>
              )}
              {props.msg.message}
            </Linkify>
            <div className={classes.timeStyle}>
              {props.convertTime(props.msg.messageDateTs)}
            </div>
          </div>
        </div>
      ) : (
        /* Display dispatcher replied message on message received from driver app */
        <div
          className={`${classes.scMessageText} ${classes.scMessageContentReceivedScMessageText}`}
        >
          <div className={classes.scMessageContentReceivedReply}>
            {props.msg.parentMessage.metadata && (
              <MessageMetaData
                color={props.metadataColor}
                metadata={props.msg.parentMessage.metadata}
              ></MessageMetaData>
            )}
            <Linkify properties={{ target: "_blank" }}>
              {props.msg.parentMessage.message}
            </Linkify>
            <div className={classes.timeStyle}>
              {props.convertTime(props.msg.parentMessage.messageDateTs)}
            </div>
          </div>
          <div className={classes.messageContainer}>
            <Linkify properties={{ target: "_blank" }}>
              {props.msg.message}
            </Linkify>
            <div className={classes.timeStyle}>
              {props.convertTime(props.msg.messageDateTs)}{" "}
              {props.renderReadIcon(props.msg.isRead, classes)}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default ReplyTextMessage;
